<script setup>
import { ElMessage, ElMessageBox } from "element-plus";
import {
  computed,
  getCurrentInstance,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { queryUserList } from "@/api/user";

const props = defineProps(["multiple"]);
const emit = defineEmits(["userSelected"]);
const { proxy } = getCurrentInstance();

const visible = ref(false);

// 遮罩
const loading = ref(true);
// 选中数组
const ids = ref([]);
// 非单个禁用
const single = ref(true);

// 用户表格数据
const userList = ref([]);

// 表格ref
const tableRef = ref(null);

// 用于反显的列表
const reverseIds = ref([]);

// 查询参数
const queryParams = reactive({
  pageNum: 1,
  pageSize: 10,
  total: 0,
  currentData: [],
});

// 查询用户列表
const getList = () => {
  loading.value = true;
  queryUserList()
    .then((res) => {
      queryParams.total = res.data.length;
      userList.value = res.data || [];
    })
    .finally(() => {
      filterList();
      loading.value = false;
    });
};

// 分页
const filterList = () => {
  let startIndex = (queryParams.pageNum - 1) * 10; // 当前页数据的起始索引
  let endIndex = startIndex + 10 - 1; // 当前页数据的结束索引
  queryParams.currentData = userList.value.slice(startIndex, endIndex + 1);
  reverseTable();
};
// 多选框选中数据
const handleSelectionChange = (selection) => {
  ids.value = selection.map((item) => item.userCode);
  single.value = selection.length != 1;
};

/** 提交按钮 */
const submitForm = () => {
  if (props.multiple) {
    emit("userSelected", ids.value);
    visible.value = false;
  } else {
    if (ids.value.length > 1) {
      ElMessage.warning("只能选择一条");
      return false;
    }
    emit("userSelected", ids.value[0]);
    visible.value = false;
  }
};

const handleDialogOpen = (config) => {
  tableRef.value?.clearSelection();
  reverseIds.value = config;
  visible.value = true;
  getList();
};

// 反选
const reverseTable = () => {
  queryParams.currentData.forEach((item) => {
    if (reverseIds.value.includes(item.userCode)) {
      console.log("6677");
      tableRef.value?.toggleRowSelection(item, true);
    }
  });
};

defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    title="人员选择"
    width="55%"
    append-to-body
    v-model="visible"
    :close-on-click-modal="false"
  >
    <el-table
      ref="tableRef"
      v-loading="loading"
      :data="queryParams.currentData"
      @selection-change="handleSelectionChange"
      row-key="userCode"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        :reserve-selection="true"
      />
      <el-table-column
        label="用户编号"
        align="center"
        key="userCode"
        prop="userCode"
      />
      <el-table-column
        label="用户名称"
        align="center"
        key="userName"
        prop="userName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="用户昵称"
        align="center"
        key="nikeName"
        prop="nikeName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="部门"
        align="center"
        key="orgName"
        prop="orgName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="手机号码"
        align="center"
        key="phone"
        prop="phone"
        width="120"
      />
    </el-table>

    <el-pagination
      v-show="queryParams.total > 0"
      :total="queryParams.total"
      v-model:current-page="queryParams.pageNum"
      @update:current-page="filterList"
      layout="->, prev, pager, next"
    />
    <template #footer>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </template>
  </el-dialog>
</template>

<style scoped>
.dialog-footer {
  position: absolute;
  top: 55px;
}
</style>
